/** Layer A vs Layer B classification for workplace comms (WC-V20-E). */
export function isWorkplaceLayerBDmKind(kind: string | null | undefined): boolean {
  return String(kind || "").trim() === "thread_message";
}
